import * as styles from './Container.module.css'

function Container({
  children,
  className = styles.container,
  contentClassName = styles.content,
  label,
  ...elementProps
}) {
  return (
    <div {...elementProps} className={className}>
      <span className={styles.label}>{label}</span>
      <div className={contentClassName}>{children}</div>
    </div>
  )
}

export default Container
